var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseBlack24Dp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4677",
    "data-name": "Trazado 4677",
    d: "M0,0H22V22H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4678",
    "data-name": "Trazado 4678",
    d: "M17.971,5.7a.97.97,0,0,0-1.374,0l-4.765,4.756L7.067,5.693A.972.972,0,0,0,5.693,7.067l4.765,4.765L5.693,16.6a.972.972,0,0,0,1.374,1.374l4.765-4.765L16.6,17.971A.972.972,0,0,0,17.971,16.6l-4.765-4.765,4.765-4.765A.977.977,0,0,0,17.971,5.7Z",
    transform: "translate(-0.832 -0.832)",
    fill: "#b2b2b2",
    stroke: "#b2b2b2",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack24Dp);
export default __webpack_public_path__ + "static/media/close_black_24dp.46255d5652a748b17d7ebce0a462ae29.svg";
export { ForwardRef as ReactComponent };